var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',[_c('h2',[_vm._v(" Evolution annuelle "+_vm._s(_vm.tyear))]),_c('br'),_c('vue-apex-charts',{ref:"charts",attrs:{"type":"bar","height":"350","options":_vm.columnChart.chartOptions,"series":_vm.columnChart.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }